export default __webpack_public_path__ + "static/media/robofriends.95d1831e.png";